import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { HttpService } from '../../shared/http/base.http';

@Injectable()
export class GlobalSearchApiService extends HttpService {
   getSearchResults(keyword: string) {
      return this.get('/globalsearch?keyword=' + keyword);
   }
}